import { mutateGraphQL } from 'common/util/query';
import { nodeWithArgs, toMutation } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

export const ACTIONS = {
    SETTING_BINDER_PIN: 'SETTING_BINDER_PIN',
    SET_BINDER_PIN: 'SET_BINDER_PIN',
};

export function setBinderPin(binderPinData) {
    return {
        type: ACTIONS.SET_BINDER_PIN,
        payload: {
            binderPinData,
        }
    };
}

export function settingBinderPin(binderId) {
    return {
        type: ACTIONS.SETTING_BINDER_PIN,
        payload: {
            binderId,
        }
    };
}

export function setBinderPinAction(binderId, isPinned) {
    return async (dispatch, getState) => {
        const setBinderPinQuery = nodeWithArgs('updateBinderPinnedStatus', {
            binderId,
            isPinned
        }, [
            'binderId',
            'isPinned',
        ]);

        dispatch(settingBinderPin(binderId));
        const results = await mutateGraphQL(toMutation(setBinderPinQuery));


        if (results.errors) {
            const pinnedStatus = isPinned ? 'pin' : 'unpin';
            dispatch(addApplicationMessage('error', `Could not ${pinnedStatus} binder`));
            dispatch(setBinderPin({ binderId, isPinned: !isPinned }));
        } else {
            return await dispatch(setBinderPin({ binderId, isPinned }));
        }
    };
}
